// Starter prompt chips for the homeowner chat empty state.
//
// This file once carried ~180 lines of prototype-era fixtures
// (fake community/company objects, a canned chat thread, a roster
// with realistic-looking emails, fabricated MRR numbers). All of it
// was dead — Vite tree-shook it from the bundle and nothing imported
// it — but it polluted grep results and read like real data
// (issue #418). STARTER_PROMPTS is the only export that ever had a
// consumer (homeowner.jsx).

const STARTER_PROMPTS = [
  { cat: "Pets", q: "Are there any restrictions on dog breeds or weight?" },
  { cat: "Rentals", q: "Can I rent my unit on Airbnb for the summer?" },
  { cat: "Exteriors", q: "What's the approval process for painting my front door?" },
  { cat: "Amenities", q: "How many guests can I bring to the pool?" },
  { cat: "Parking", q: "Where can my contractor's truck park overnight?" },
  { cat: "Fees", q: "When are 2026 dues posted and what's the late penalty?" },
];

export { STARTER_PROMPTS };
